import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import IncreaseLowRiskLimitModal from 'components/auth/history/modals/IncreaseLowRiskLimitModal';
import { InfoPage } from 'components/common/Layout/InfoPage/InfoPage';

import { SCREEN } from 'constants/amplitude/AmplitudeParamName';
import { CLOSE_TO_LIMIT } from 'constants/amplitude/AmplitudeParamValues';
import { AUTH_SEND_MAIN_LINK } from 'constants/UrlConstants';

import amplitude from 'amplitude-js';
import { usePageMessages } from 'hooks/selectors';

import { INCREASE_LIMITS_SHOWN } from '../../../constants/amplitude/AmplitudeEvents';

const PromoLowRiskUpgradeLimit = (props) => {
    const { notNowButton, quickHeadsUpPurple, quickHeadsUp, increaseLimitButton } = usePageMessages();

    useEffect(() => {
        amplitude.getInstance().logEvent(INCREASE_LIMITS_SHOWN, { [SCREEN]: CLOSE_TO_LIMIT });
    }, []);

    const text = (
        <>
            <span>{quickHeadsUpPurple}</span>
            <br />
            {quickHeadsUp}
        </>
    );

    return (
        <InfoPage
            iconName="zap-thin"
            iconColor="purple"
            headerText={text}
            topButtonType="link"
            topButtonCaption={notNowButton}
            topButtonLink={AUTH_SEND_MAIN_LINK}
            primaryButtonCaption={increaseLimitButton}
            primaryButtonType="link"
            primaryButtonOnClick={(e) => {
                e?.preventDefault();
                props.modalRef.current.open(<IncreaseLowRiskLimitModal modalRef={props.modalRef} notNowLink={AUTH_SEND_MAIN_LINK} />);
            }}
        />
    );
};
PromoLowRiskUpgradeLimit.propTypes = {
    modalRef: PropTypes.object.isRequired,
};

export default PromoLowRiskUpgradeLimit;
